import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { DataManager } from '@syncfusion/ej2-data';
import { TranslateService } from '@ngx-translate/core';
import { saveAs as importedSaveAs } from "file-saver";
import { HttpService } from '../../services/http.service';
import { HelperService } from '../../services/helper.service';
import { NotifyService } from '../../services/notify.service';
import { SidebarService } from '../../sidebar/sidebar.service';
import { AuthenService } from '../../services/authen.service';
import { Router } from '@angular/router';
import { UrlParams } from '../../helpers/url-params';
import { MasterBase } from '../../base/master-base';
import * as AppConst from '../../data/test.data';
import { PageSettingsModel } from '@syncfusion/ej2-angular-grids';



import { MyImportFileDialogComponent } from "../../dialogs/my-import-file-dialog/my-import-file-dialog";
import { debug } from 'util';

@Component({
    templateUrl: './hospital-profile-search.html',
    styleUrls: ['./hospital-profile-search.css'],
})




export class HospitalProfileSearchComponent extends MasterBase implements OnInit, OnDestroy {

    @ViewChild('dlgImport') dlgImport: MyImportFileDialogComponent;
    waiting: boolean = false;
    loginUser: string = "";
    isSCFFM: boolean = false;
    NameValueFields: Object = { text: 'Name', value: 'Value' };

    statusSearch: string = "All";
    arrStatus: Array<any> = [
        { "Value": "All", "Name": "All" },
        { "Value": "waiting", "Name": "Waiting" },
        { "Value": "approved", "Name": "Approved" },
        { "Value": "rejected", "Name": "Rejected" }
    ];

    provinceSearch: string = "All";
    arrProvince: Array<any>= [
        { "Value": "", "Name": "All" },
    ];

    bcCodeSearch: string = "";
    keyworSearch: string = "";

    totalCodeChangeWaiting: number = 0;

    constructor(auth: AuthenService, http: HttpService, helper: HelperService, notify: NotifyService, translate: TranslateService, private sidebar: SidebarService, private router: Router) {
        super(auth, http, helper, notify, translate);

        
        this.loginUser = this.auth.LoginUser;
        this.isSCFFM = this.auth.isSCFFM;
    }

    ngOnDestroy() {
    }

    ngOnInit() {
        debugger;
        this.getCounterHospitalChange();
        this.onSearch();

    }

    onSearch() {
        let params = new UrlParams();

        let dataFilter = {
            "Status": this.statusSearch,
            "ProvinceCode": this.provinceSearch,
            "BcCode": this.bcCodeSearch,
            "Keyword": this.keyworSearch
        };

        params.add('filter', JSON.stringify(dataFilter));
        this.gridData = this.http.getByManager(`api/HospitalProfile/SearchPageHospitalProfile?${params.toString()}`, this.auth);
   
    }

    onExport() {


        let params = new UrlParams();
        params.add('Status', this.statusSearch);
        params.add('ProvinceCode', this.provinceSearch);
        params.add('BcCode', this.bcCodeSearch);
        params.add('Keyword', this.keyworSearch);

        this.waiting = true;
        this.http.download(`api/HospitalProfile/ExportSearchHospitalProfile?${params.toString()}`, res => {
            let fileNameExport = 'HospitalProfile-Export.xlsx';
            importedSaveAs(res, fileNameExport);
            this.waiting = false;
        });


    }

    onDelete(customerCode: string) {
        this.helper.confirm('Are you sure you want to remove this item ?', () => {
            this.http.get(`api/HospitalProfile/DeleteHospitalProfile?customerCode=${customerCode}`, res => {
                this.helper.alert("Delete successfully !");
                this.onSearch();
            });
        });
    }

    getCounterHospitalChange() {
        let dataFilter = {
            "Status": "waiting",
            "ProvinceCode": "All",
            "BcCode": "",
            "Keyword": ""
        };

        this.http.get(`api/HospitalProfile/SearchPageHospitalProfile?filter=${JSON.stringify(dataFilter)}`, res => {
            this.totalCodeChangeWaiting = res.TotalRows;
        });
    }


    viewChangesWaiting() {
        this.statusSearch = "waiting";
        this.provinceSearch = "All";
        this.bcCodeSearch = "";
        this.keyworSearch = "";
        this.onSearch();
    }


}
